import type {
  CurrentRefinementsConnectorParamsItem,
  CurrentRefinementsConnectorParamsRefinement,
} from 'instantsearch.js/es/connectors/current-refinements/connectCurrentRefinements';

const compareRefinementObject = (
  a: CurrentRefinementsConnectorParamsRefinement | null | undefined,
  b: CurrentRefinementsConnectorParamsRefinement | null | undefined
): boolean => {
  if (a === b) {
    return true;
  }

  if (!a || !b) {
    return false;
  }

  return (
    // skip 'count' property
    a.attribute === b.attribute && a.label === b.label && a.type === b.type && a.value === b.value
  );
};

const compareRefinements = (
  a: CurrentRefinementsConnectorParamsRefinement[] | null | undefined,
  b: CurrentRefinementsConnectorParamsRefinement[] | null | undefined
): boolean => {
  if (a === b) {
    return true;
  }

  if (!a || !b) {
    return false;
  }

  if (!Array.isArray(a) || !Array.isArray(b)) {
    return false;
  }

  if (a.length !== b.length) {
    return false;
  }

  for (let i = 0; i < a.length; i++) {
    if (!compareRefinementObject(a[i], b[i])) {
      return false;
    }
  }

  return true;
};

const compareFacetObject = (
  a: CurrentRefinementsConnectorParamsItem | null | undefined,
  b: CurrentRefinementsConnectorParamsItem | null | undefined
): boolean => {
  if (a === b) {
    return true;
  }

  if (!a || !b) {
    return false;
  }

  if (a.attribute !== b.attribute) {
    return false;
  }

  if (a.indexId !== b.indexId) {
    return false;
  }

  if (a.indexName !== b.indexName) {
    return false;
  }

  if (a.label !== b.label) {
    return false;
  }

  return compareRefinements(a.refinements, b.refinements);
};

export const areFacetsEqual = (
  a: CurrentRefinementsConnectorParamsItem[],
  b: CurrentRefinementsConnectorParamsItem[]
): boolean => {
  if (!a || !b) {
    return false;
  }

  if (a === b) {
    return true;
  }

  if (!Array.isArray(a) || !Array.isArray(b)) {
    return false;
  }

  if (a.length !== b.length) {
    return false;
  }

  for (let i = 0; i < a.length; i++) {
    if (!compareFacetObject(a[i], b[i])) {
      return false;
    }
  }

  return true;
};
